import { CreateWebhookRequestDto, WebhookDto } from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';

class Actions extends CaEntityActionsFactory<
  WebhookDto,
  Partial<CreateWebhookRequestDto>,
  WebhookDto,
  BaseFilterType
> {
  constructor() {
    super('webhooks');
  }
}

export const WebhooksActions = new Actions();
